import React from 'react'
import { richTextToComponents } from '../../utils/gatsby/richTextToComponents'
import { TabPanel } from '@components/Tabs/index'
import { tabsObject } from '@utils'
import List from './List'
import EventList from './EventList'
import { StyledTabH1 } from './style'
import Html from '@components/Html'

const TabContent = ({ tabsArr, data, pro = false, setTab, tab }) => {
  return (
    <>
      {tabsArr &&
        tabsArr.map((tabData, index) => {
          if (tabData === 'overview') {
            return (
              <TabPanel index={index} key={index} tab={tab} setTab={setTab}>
                {data?.overviewTab?.map(
                  (overviewTab, i) =>
                    overviewTab?.html &&
                    overviewTab?.title && (
                      <React.Fragment key={`${i}-${overviewTab.title}`}>
                        <StyledTabH1
                          marginBottom={25}
                          smallerText="2.5"
                          upperCase
                          color="navy"
                          className="qtph-profprofile-overview-header-txt"
                        >
                          {overviewTab.title}
                        </StyledTabH1>
                        <Html contentHtml={overviewTab.html} professional />
                      </React.Fragment>
                    )
                )}
              </TabPanel>
            )
          }
          if (tabData === 'events') {
            return (
              <TabPanel
                index={index}
                tab={tab}
                setTab={setTab}
                key={tabsObject[tabData]}
                label="news-content"
              >
                <EventList
                  tabName={tabsObject[tabData]}
                  listContent={data[tabData]}
                />
              </TabPanel>
            )
          }
          if (
            tabData === 'news' ||
            tabData === 'insights' ||
            tabData === 'rankings'
          ) {
            return (
              <TabPanel
                index={index}
                tab={tab}
                setTab={setTab}
                key={tabsObject[tabData]}
                label="news-content"
              >
                <StyledTabH1
                  marginBottom={25}
                  smallerText="2.5"
                  upperCase
                  color="navy"
                >
                  {tabsObject[tabData]}
                </StyledTabH1>
                <List
                  tabName={tabsObject[tabData]}
                  listContent={data[tabData]}
                />
              </TabPanel>
            )
          }
          if (
            [
              'bioEducationHtml',
              'bioAccoladesHtml',
              'recentRepresentationsHtml',
              'involvementHtml',
              'speakingEngagementsHtml',
            ].includes(tabData)
          ) {
            return (
              <TabPanel index={index} key={index} tab={tab} setTab={setTab}>
                <StyledTabH1
                  marginBottom={25}
                  smallerText="2.5"
                  upperCase
                  color="navy"
                >
                  {tabsObject[tabData]}
                </StyledTabH1>
                <Html contentHtml={data?.[tabData]} professional />
              </TabPanel>
            )
          } else {
            return (
              <TabPanel index={index} key={index} tab={tab} setTab={setTab}>
                <StyledTabH1
                  marginBottom={25}
                  smallerText="2.5"
                  upperCase
                  color="navy"
                >
                  {tabsObject[tabData]}
                </StyledTabH1>
                {richTextToComponents(data?.[tabData])}
              </TabPanel>
            )
          }
        })}
    </>
  )
}

export default TabContent
